import { Link } from "react-router-dom";
import { CATEGORIES } from "@/lib/categories";
import { NewsletterSignup } from "@/components/NewsletterSignup";
import { Brand } from "@/components/Brand";
import { openCookiePreferences } from "@/lib/consent";
import { useFillCount } from "@/lib/useFillCount";

export function Footer() {
  const pickets = useFillCount(30);
  return (
    <footer className="bg-ink-deep mt-24">
      <div className="wood-fence" aria-hidden="true" data-testid="footer-fence">
        {Array.from({ length: pickets }).map((_, i) => {
          const c = CATEGORIES[Math.min(CATEGORIES.length - 1, Math.floor(i / (pickets / CATEGORIES.length)))];
          return <span key={i} className="wood-plank" style={{ "--cat": c.hex }} />;
        })}
      </div>
      <div className="max-w-7xl mx-auto px-4 pt-14 pb-8">
        <div className="pb-12 mb-12 border-b-2 border-dashed border-line">
          <NewsletterSignup />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div data-testid="footer-brand" className="mb-5"><Brand size="md" tagline={false} /></div>
            <p className="text-sm leading-relaxed text-stone-600 max-w-md">
              Notizie, guide e valori indicativi dal mondo del collezionismo. I contenuti sono
              rielaborazioni originali con citazione e link alla fonte, validati dalla redazione
              prima della pubblicazione.
            </p>
          </div>
          <div>
            <h3 className="font-meta uppercase tracking-[0.18em] text-[10px] text-gold mb-4">Categorie</h3>
            <ul className="space-y-2.5 text-sm">
              {CATEGORIES.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link to={`/categoria/${c.slug}`} className="text-stone-600 hover:text-stone-900 transition-colors flex items-center gap-2">
                    <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />{c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-meta uppercase tracking-[0.18em] text-[10px] text-gold mb-4">Portale</h3>
            <ul className="space-y-2.5 text-sm text-stone-600">
              <li><Link to="/guide" className="hover:text-stone-900 transition-colors">Guide</Link></li>
              <li><Link to="/valori" className="hover:text-stone-900 transition-colors">Schede Valore</Link></li>
              <li><Link to="/chi-siamo" className="hover:text-stone-900 transition-colors">Chi siamo</Link></li>
              <li><Link to="/collezionismo" data-testid="footer-link-pillar" className="hover:text-stone-900 transition-colors">Guida al collezionismo</Link></li>
              <li><Link to="/come-iniziare" data-testid="footer-link-starters" className="hover:text-stone-900 transition-colors">Come iniziare, per categoria</Link></li>
              <li><Link to="/admin" className="hover:text-stone-900 transition-colors">Area Redazione</Link></li>
              <li>
                <a href="/api/feed.xml" data-testid="footer-rss" className="hover:text-stone-900 transition-colors">Feed RSS</a>
              </li>
            </ul>
            <h3 className="font-meta uppercase tracking-[0.18em] text-[10px] text-gold mt-7 mb-4">Legale</h3>
            <ul className="space-y-2.5 text-sm text-stone-600" data-testid="footer-legal-links">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-stone-900 transition-colors">Privacy</Link></li>
              <li><Link to="/cookie" data-testid="footer-link-cookie" className="hover:text-stone-900 transition-colors">Cookie policy</Link></li>
              <li><Link to="/termini" data-testid="footer-link-termini" className="hover:text-stone-900 transition-colors">Termini e condizioni</Link></li>
              <li><Link to="/note-legali" data-testid="footer-link-note-legali" className="hover:text-stone-900 transition-colors">Note legali & copyright</Link></li>
              <li><Link to="/disclaimer" data-testid="footer-link-disclaimer" className="hover:text-stone-900 transition-colors">Disclaimer</Link></li>
              <li>
                <button type="button" onClick={openCookiePreferences} data-testid="footer-cookie-preferences"
                  className="hover:text-stone-900 transition-colors underline decoration-dotted decoration-stone-400 underline-offset-2">
                  Preferenze cookie
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div data-testid="footer-disclaimer" className="mt-12 p-4 rounded-2xl bg-panel border-2 border-dashed border-line text-xs leading-relaxed text-stone-500">
          <p className="mb-2">
            <strong className="text-stone-700">Disclaimer finanziario:</strong> nessun contenuto di questo sito
            costituisce consulenza finanziaria o d'investimento. Le informazioni, le stime e i valori sono
            puramente indicativi e a scopo informativo. Ogni scelta di acquisto, vendita o investimento è a
            rischio esclusivo dell'utente e nessuno si assume responsabilità per eventuali perdite economiche.
          </p>
          <p>© {new Date().getFullYear()} Collezionatico · Contenuti rielaborati con attribuzione alla fonte.</p>
          <p className="mt-2">
            Articoli redatti con l'ausilio dell'intelligenza artificiale e <strong className="text-stone-700">sempre revisionati
            da una persona</strong> prima della pubblicazione. Marchi e nomi citati appartengono ai rispettivi titolari e sono
            richiamati a fini descrittivi: non siamo affiliati né autorizzati da essi. Testata non registrata, aggiornata senza
            periodicità prestabilita.
          </p>
        </div>
      </div>
    </footer>
  );
}
